import { VehicleSearchReviewResult } from '../../../app/models/Admin';

export const vehicleSearchReviewOptions: { value: VehicleSearchReviewResult; label: string }[] = [
  { value: 'NotReviewed', label: 'Not reviewed' },
  { value: 'NotFound', label: 'Not found' },
  { value: 'FoundUntested', label: 'Found but untested' },
  { value: 'TestPassed', label: 'Test passed' },
  { value: 'IssueObserved', label: 'Issue observed' },
];

export const vehicleSearchReviewLabel = (value?: string) =>
  vehicleSearchReviewOptions.find(option => option.value === value)?.label || 'Not reviewed';
